export const featuredArtworks = [
  {
    id: 13,
    title: "Lamento Borincano",
    price: "$2,375",
    technique: "Mixto",
    dimensions: "30 x 40 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/010f8ef0a44444fb7f5e5f024194d76a.jpeg",
    category: "Abstracto",
    sold: true
  },
  {
    id: 9,
    title: "Rising Sun",
    price: "$1,575",
    technique: "Acrílico sobre lienzo",
    dimensions: "24 x 36 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/277526ab2e046ae41f11fbfd56d2adbf.jpeg",
    category: "Abstracto",
    sold: true
  },
  {
    id: 1,
    title: "Angélica Valeria",
    price: "$1,575",
    technique: "Acrílico sobre lienzo",
    dimensions: "16 x 20 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/58cfceb1c35836a14b0e1db23a1af7d4.jpeg",
    category: "Abstracto",
    sold: true
  },
  {
    id: 2,
    title: "Build yourselfs",
    price: "$1,575",
    technique: "Acrílico sobre lienzo",
    dimensions: "24 x 30 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/c12508ddfa47889220332b4cab13c369.jpeg",
    category: "Contemporáneo",
    sold: true
  },
  {
    id: 3,
    title: "Epidermal Elegance",
    price: "$2,100",
    technique: "Mixta",
    dimensions: "36 x 48 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/1b994b2e08119b466fe20dbf70c50c7a.jpeg",
    category: "Naturaleza",
    sold: true
  },
  {
    id: 4,
    title: "Facial Essence",
    price: "$2,800",
    technique: "Acrílico sobre lienzo",
    dimensions: "24 x 30 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/7c5c25b77bdc9a99793a0ce883520263.jpeg",
    category: "Abstracto",
    sold: true
  },
  {
    id: 5,
    title: "El Caballero de los Leones",
    price: "$750.00",
    technique: "Acrílico sobre lienzo",
    dimensions: "16 x 20 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/740f1e3137bde93d7d8cd0a95a51cff3.jpeg",
    category: "Abstracto",
    sold: true
  },
  {
    id: 6,
    title: "Dreaming",
    price: "$1,950",
    technique: "Mixta",
    dimensions: "16 x 20 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/483c672be06e1850e6907272c6145618.jpeg",
    category: "Naturaleza",
    sold: false
  },
  {
    id: 7,
    title: "Glaring",
    price: "$3,500",
    technique: "Acrílico sobre lienzo",
    dimensions: "24 x 30 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/c03228bbf14fe7a3e241a3f4b2e5776d.jpeg",
    category: "Abstracto",
    sold: true
  },
  {
    id: 8,
    title: "Emotive Complexion",
    price: "$2,100",
    technique: "Acrílico sobre lienzo",
    dimensions: "48 x 48 inch",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/9f1e3dbadc7d88175ab71e29bc3e23fd.jpeg",
    category: "Contemporáneo",
    sold: true
  }
];

export const galleryImages = [
  {
    id: 1,
    title: "Metamorfosis",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/cf1629847dc0bbf8486ea16d3b98d8de.jpeg",
    category: "Abstracto"
  },
  {
    id: 2,
    title: "Respira…",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/3ce198f2b268a921e3685f6b1063df3e.jpeg",
    category: "Contemporáneo"
  },
  {
    id: 3,
    title: "Fragmentos de patria: Justicia y Verdad",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/4db92c537255ef7c811b7daa444e8128.jpeg",
    category: "Minimalista"
  },
  {
    id: 4,
    title: "Reyes de Luz",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/44f839e23654e2af7aed2b1afdbf6aab.jpeg",
    category: "Naturaleza"
  },
  {
    id: 5,
    title: "El Peso del Pueblo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/8b004e41b81aa12d8ddc786849b674f0.jpeg",
    category: "Naturaleza"
  },
  {
    id: 6,
    title: "Rising Sun",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/277526ab2e046ae41f11fbfd56d2adbf.jpeg",
    category: "Abstracto"
  },
  {
    id: 7,
    title: "Rojo 44",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/3b70a1f7182c866b4468ec17055da889.jpeg",
    category: "Abstracto"
  },
  {
    id: 8,
    title: "GR-63",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/7b8e1da4a540014777b18efb83c7dc3b.jpeg",
    category: "Naturaleza"
  },
  {
    id: 9,
    title: "Fragmentos de Identidad",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/f7f3d86e9d33531ff66b9356cd9aade3.jpeg",
    category: "Abstracto"
  },
  {
    id: 10,
    title: "Morning Light",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/67aacad7ab995e71e6ba6fdaee5726e9.jpeg",
    category: "Contemporáneo"
  },
  {
    id: 11,
    title: "Build yourselfs",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/c12508ddfa47889220332b4cab13c369.jpeg",
    category: "Abstracto"
  },
  {
    id: 12,
    title: "Harmony",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/278d851c1e853fba371a0888e7a834d2.jpeg",
    category: "Contemporáneo"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    location: "San Juan, Puerto Rico",
    text: "La obra de David transformó completamente mi espacio. Cada día descubro nuevos detalles que me inspiran. Su arte tiene una profundidad emocional única.",
    avatar: "https://public.readdy.ai/ai/img_res/f0198b59d46af44324f8e31722fddab6.jpg",
    rating: 5
  },
  {
    id: 2,
    name: "Carlos Mendoza",
    location: "Orlando, Florida",
    text: "Compré tres piezas para mi oficina y mis clientes siempre comentan sobre ellas. El arte de David es una inversión que vale cada dólar.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20businessman%20art%20collector%20simple%20clean%20background&width=100&height=100&seq=testimonial2&orientation=squarish",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Martínez",
    location: "Ponce, Puerto Rico",
    text: "David captura emociones de una manera extraordinaria. Su proceso creativo es fascinante y el resultado final siempre supera las expectativas.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20woman%20art%20enthusiast%20simple%20clean%20background&width=100&height=100&seq=testimonial3&orientation=squarish",
    rating: 5
  },
  {
    id: 4,
    name: "Roberto Silva",
    location: "Orlando, Florida",
    text: "Como coleccionista de arte contemporáneo, puedo decir que David Nieves es uno de los artistas más prometedores de su generación.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20mature%20man%20art%20collector%20simple%20clean%20background&width=100&height=100&seq=testimonial4&orientation=squarish",
    rating: 5
  },
  {
    id: 5,
    name: "Laura Fernández",
    location: "Mayagüez, Puerto Rico",
    text: "La atención al detalle y la calidad de cada pieza es impecable. David es un verdadero profesional y su pasión por el arte es evidente.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20elegant%20woman%20interior%20designer%20simple%20clean%20background&width=100&height=100&seq=testimonial5&orientation=squarish",
    rating: 5
  }
];

export const instagramPosts = [
  {
    id: 1,
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/3ce198f2b268a921e3685f6b1063df3e.jpeg",
    likes: 1243,
    comments: 87
  },
  {
    id: 2,
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/cf1629847dc0bbf8486ea16d3b98d8de.jpeg",
    likes: 2156,
    comments: 134
  },
  {
    id: 3,
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/94e9d03d04c235e03eead3496af3f2ad.jpeg",
    likes: 1876,
    comments: 92
  },
  {
    id: 4,
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/75a4d8bef836f74aa5a9f6172d661df5.jpeg",
    likes: 1534,
    comments: 76
  },
  {
    id: 5,
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/9f1e3dbadc7d88175ab71e29bc3e23fd.jpeg",
    likes: 1987,
    comments: 112
  },
  {
    id: 6,
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/43db9529dc008da577de7451962438ed.jpeg",
    likes: 2341,
    comments: 156
  },
  {
    id: 7,
    image: "https://readdy.ai/api/search-image?query=art%20exhibition%20opening%20with%20people%20viewing%20abstract%20paintings%20gallery%20event%20contemporary%20art%20show%20simple%20background&width=600&height=600&seq=instagram7&orientation=squarish",
    likes: 1654,
    comments: 98
  },
  {
    id: 8,
    image: "https://readdy.ai/api/search-image?query=serene%20abstract%20artwork%20with%20soft%20colors%20peaceful%20composition%20contemporary%20painting%20simple%20clean%20background&width=600&height=600&seq=instagram8&orientation=squarish",
    likes: 1432,
    comments: 71
  },
  {
    id: 9,
    image: "https://readdy.ai/api/search-image?query=artist%20working%20on%20large%20canvas%20abstract%20painting%20creative%20process%20studio%20environment%20contemporary%20art%20simple%20background&width=600&height=600&seq=instagram9&orientation=squarish",
    likes: 1765,
    comments: 89
  }
];

export const artworks = [
  // Lamento Borincano ahora en primera posición
  {
    id: 13,
    title: "Lamento Borincano",
    year: "2026",
    price: 2375,
    category: "landscape",
    description: "Lamento Borincano es un retrato expresivo que rinde homenaje al jíbaro puertorriqueño como símbolo de identidad, resistencia y memoria colectiva. A través de una paleta vibrante y pinceladas gestuales, la obra transmite nostalgia, dignidad y fuerza interior. Una pieza cargada de emoción y carácter, ideal para coleccionistas que valoran el arte con raíz cultural y profundidad humana.",
    dimensions: "30 x 40 inch",
    medium: "Mixto",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/010f8ef0a44444fb7f5e5f024194d76a.jpeg",
    sold: true
  },
  // Rising Sun en segunda posición
  {
    id: 9,
    title: "Rising Sun",
    year: "2026",
    price: 1575,
    category: "abstract",
    description: "Rising Sun es una obra abstracta que simboliza renovación, energía y equilibrio interior. A través de capas de ocres, rojos y amarillos, la composición evoca un sol emergente rodeado de movimiento y gestos circulares que sugieren ciclos, tiempo y transformación. Las texturas y líneas espontáneas aportan profundidad y dinamismo, haciendo de esta pieza una expresión cálida y contemplativa, perfecta para espacios que buscan fuerza visual y armonía emocional.",
    dimensions: "24 x 36 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/277526ab2e046ae41f11fbfd56d2adbf.jpeg",
    sold: true
  },
  // Reyes de Luz en tercera posición
  {
    id: 12,
    title: "Reyes de Luz",
    year: "2025",
    price: 2600,
    category: "landscape",
    description: "Reyes de Luz es una obra que celebra la majestuosidad, el poder y la conexión espiritual con la naturaleza. A través de una paleta vibrante y gestos expresivos, la composición evoca figuras simbólicas que representan liderazgo, sabiduría y energía luminosa. Una pieza de gran presencia visual, ideal para espacios que buscan fuerza, carácter y profundidad emocional.",
    dimensions: "95 x 115 cm",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/44f839e23654e2af7aed2b1afdbf6aab.jpeg",
    sold: false
  },
  // Obras destacadas de "Adquiere Arte Original"
  {
    id: 1,
    title: "Angélica Valeria",
    year: "2024",
    price: 1575,
    category: "abstract",
    description: "Angélica Valeria es un retrato contemporáneo de gran fuerza emocional, donde la mirada se convierte en el centro absoluto de la composición. A través de pinceladas expresivas y una paleta dominada por azules profundos, negros y acentos cálidos, la obra transmite misterio, sensibilidad y carácter. La fragmentación del color y la textura refuerzan una sensación de introspección y presencia, haciendo de esta pieza una declaración visual intensa y elegante.",
    dimensions: "16 x 20 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/58cfceb1c35836a14b0e1db23a1af7d4.jpeg",
    sold: true
  },
  {
    id: 2,
    title: "Build yourselfs",
    year: "2024",
    price: 1575,
    category: "abstract",
    description: " es un retrato contemporáneo que aborda la introspección, el silencio y la construcción de la identidad. La figura central, marcada por contrastes y gestos fragmentados, sugiere un proceso interno de reflexión y autodefinición. La paleta contenida de grises, negros, blancos y acentos azules refuerza una atmósfera íntima y profunda, invitando al espectador a conectar con el poder del pensamiento y la transformación personal.",
    dimensions: "24 x 30 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/c12508ddfa47889220332b4cab13c369.jpeg",
    sold: true
  },
  {
    id: 3,
    title: "Epidermal Elegance",
    year: "2024",
    price: 2100,
    category: "landscape",
    description: "Epidermal Elegance es un retrato contemporáneo que celebra la belleza y complejidad de la expresión humana. A través de capas gestuales de grises, negros, azules intensos y acentos dorados, la obra transmite sofisticación, sensibilidad y fuerza interior. La fragmentación del color y el trazo expresivo crean una presencia visual envolvente, donde la piel se convierte en un territorio emocional y estético.",
    dimensions: "36 x 48 inch",
    medium: "Mixta",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/1b994b2e08119b466fe20dbf70c50c7a.jpeg",
    sold: true
  },
  {
    id: 4,
    title: "Facial Essence",
    year: "2024",
    price: 1575,
    category: "abstract",
    description: "Una sinfonía nocturna expresada en azules profundos y negros que evocan el misterio y la belleza de la medianoche.",
    dimensions: "24 x 30 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/7c5c25b77bdc9a99793a0ce883520263.jpeg",
    sold: true
  },
  {
    id: 5,
    title: "El Caballero de los Leones",
    year: "2024",
    price: 750,
    category: "abstract",
    description: "El Caballero de los Leones es un retrato figurativo de carácter simbólico que evoca honor, valentía y memoria histórica. La figura central, de mirada firme y gesto sereno, remite al arquetipo del caballero como guardián de principios y tradiciones. El uso de colores intensos y pinceladas expresivas aporta dinamismo y contemporaneidad, creando un diálogo entre lo heroico y lo humano. La obra transmite dignidad, fuerza interior y una presencia atemporal..",
    dimensions: "16 x 20 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/740f1e3137bde93d7d8cd0a95a51cff3.jpeg",
    sold: true
  },
  {
    id: 6,
    title: "Dreaming",
    year: "2024",
    price: 1950,
    category: "landscape",
    description: "Dreaming es un retrato contemporáneo que explora la introspección y el mundo interior del pensamiento. La figura, representada de perfil, parece suspendida entre la realidad y la contemplación, mientras capas de azules, ocres y grises crean una atmósfera de silencio y profundidad emocional. Las pinceladas sueltas y la fragmentación del color refuerzan una sensación de pausa, invitando al espectador a un estado de reflexión y calma interior.",
    dimensions: "16 x 20 inch",
    medium: "Mixta",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/483c672be06e1850e6907272c6145618.jpeg",
    sold: false
  },
  {
    id: 7,
    title: "Glaring",
    year: "2024",
    price: 2375,
    category: "abstract",
    description: "Glaring es un retrato abstracto–expresionista de alto impacto emocional, donde la intensidad de la mirada domina la composición. El contraste dramático entre blancos, negros y acentos cálidos crea una tensión visual que transmite confrontación, fuerza y vulnerabilidad a la vez. Las pinceladas enérgicas y los trazos fragmentados sugieren emoción cruda y movimiento, convirtiendo la obra en una exploración directa del carácter y la presencia humana.",
    dimensions: "24 x 30 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/c03228bbf14fe7a3e241a3f4b2e5776d.jpeg",
    sold: true
  },
  {
    id: 8,
    title: "Emotive Complexion",
    year: "2024",
    price: 2100,
    category: "abstract",
    description: "Emotive Complexion es un retrato contemporáneo que explora la complejidad emocional del rostro humano. A través de contrastes marcados, gestos enérgicos y una paleta dominada por negros, grises, azules profundos y acentos cálidos, la obra transmite introspección, fuerza y sensibilidad. La fragmentación del color y la expresión del trazo crean una tensión visual que refleja la dualidad entre lo interno y lo externo.",
    dimensions: "48 x 48 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/9f1e3dbadc7d88175ab71e29bc3e23fd.jpeg",
    sold: true
  },
  // Obras adicionales de la galería
  {
    id: 10,
    title: "GR-63",
    year: "2025",
    price: 1575,
    category: "abstract",
    description: "GR-63 es una obra de alto impacto visual que captura la intensidad, la velocidad y la concentración del automovilismo de élite. A través de una composición frontal y una paleta dominada por azules, negros y acentos vibrantes, el artista transforma el casco del piloto en un ícono contemporáneo de precisión, riesgo y adrenalina. Las pinceladas gestuales y los trazos expresivos transmiten movimiento y tensión, convirtiendo la pieza en una declaración de fuerza, tecnología y carácter competitivo.",
    dimensions: "24 x 30 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/7b8e1da4a540014777b18efb83c7dc3b.jpeg",
    sold: true
  },
  {
    id: 11,
    title: "Fragmentos de patria: Justicia y Verdad",
    year: "2025",
    price: 2200,
    category: "abstract",
    description: "Fragmentos de Patria: Justicia y Verdad es una obra cargada de simbolismo que reflexiona sobre la identidad, la nación y los valores fundamentales de Puerto Rico. La figura del coquí, emblema de resistencia y pertenencia, se integra a los colores de la bandera puertorriqueña mediante pinceladas gestuales y capas fragmentadas. La composición transmite una tensión entre esperanza y lucha, invitando a una reflexión profunda sobre la justicia, la verdad y el sentido de patria en un contexto contemporáneo.",
    dimensions: "36 x 36 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/213ab1090404df76d03eb5436aecdfa9.jpeg"
  },
  {
    id: 14,
    title: "Desert Mirage",
    year: "2023",
    price: 2200,
    category: "landscape",
    description: "Los tonos cálidos del desierto se fusionan en una composición que evoca el calor y la vastedad de paisajes áridos.",
    dimensions: "85 x 105 cm",
    medium: "Mixta",
    image: "https://readdy.ai/api/search-image?query=desert%20inspired%20abstract%20art%20with%20sandy%20warm%20tones%20minimalist%20composition%20contemporary%20style%20simple%20clean%20background%20gallery%20quality%20professional%20photography&width=800&height=1000&seq=artwork-full-6&orientation=portrait"
  },
  {
    id: 15,
    title: "Rojo 44",
    year: "2025",
    price: 1575,
    category: "abstract",
    description: "Rojo 44 es una obra vibrante que encarna la pasión, la velocidad y la intensidad del automovilismo de alto rendimiento. Dominada por rojos profundos y amarillos eléctricos, la composición frontal del casco convierte al piloto en un ícono de fuerza, enfoque y determinación. Las pinceladas enérgicas y los contrastes cromáticos transmiten movimiento y adrenalina, haciendo de esta pieza una declaración poderosa sobre competencia, carácter y excelencia.",
    dimensions: "24 x 30 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/3b70a1f7182c866b4468ec17055da889.jpeg",
    sold: true
  },
  {
    id: 16,
    title: "Colorful Bubbles",
    year: "2026",
    price: 1575,
    category: "abstract",
    description: "Colorful Bubbles es una obra abstracta contemporánea llena de energía y movimiento. Capas de color vibrante, gestos espontáneos y formas circulares crean una composición dinámica que transmite alegría, fluidez y vitalidad. Una pieza moderna y expresiva, perfecta para espacios que buscan impacto visual, ritmo y una atmósfera creativa.",
    dimensions: "24 x 36 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/98e7e1def5bdea879d6c15d55ba0d720.jpeg",
    sold: true
  },
  {
    id: 17,
    title: "Cosmic Journey",
    year: "2023",
    price: 3800,
    category: "abstract",
    description: "Un viaje a través del cosmos plasmado en colores profundos y formas celestiales que invitan a la contemplación del universo.",
    dimensions: "130 x 160 cm",
    medium: "Acrílico sobre lienzo",
    image: "https://readdy.ai/api/search-image?query=cosmic%20space%20inspired%20abstract%20art%20with%20deep%20colors%20celestial%20feeling%20contemporary%20style%20simple%20clean%20background%20gallery%20quality%20professional%20photography&width=1000&height=800&seq=artwork-full-9&orientation=landscape"
  },
  {
    id: 18,
    title: "Fragmentos de Identidad",
    year: "2025",
    price: 1575,
    category: "abstract",
    description: "Fragmentos de Identidad es un retrato contemporáneo que explora la construcción del yo a través de capas, contrastes y gestos fragmentados. La composición parcial del rostro y la paleta vibrante de azules, rojos y tonos piel sugieren memoria, transformación y dualidad. La obra invita al espectador a reflexionar sobre la identidad como un proceso dinámico, íntimo y en constante evolución.",
    dimensions: "24 x 36 inch",
    medium: "Mixta",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/5900e2ad148304a01e6d2a3dabdbfd35.jpeg"
  },
  {
    id: 20,
    title: "Metamorfosis",
    year: "2025",
    price: 1750,
    category: "abstract",
    description: "Metamorfosis es una obra que simboliza cambio, transformación y renacimiento. La figura femenina, atravesada por la imagen de una mariposa, representa el proceso interno de evolución y liberación. La paleta vibrante de azules, ocres y negros, junto a pinceladas gestuales, crea una atmósfera de fuerza y sensibilidad, invitando al espectador a reflexionar sobre la identidad como un estado en constante transformación.",
    dimensions: "36 x 36 inch",
    medium: "Acrílico sobre lienzo",
    image: "https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/6ddea60e04e426f8735542fc74018f11.jpeg",
    sold: true
  }
];